export default "__VITE_ASSET__WOAqSR56__"